/* eslint-disable no-magic-numbers */
import React, { useState } from 'react';

import { TOP_SEARCHED_WATERS } from '../../../constants/fishingWaters/topSearchedWaters';
import { useIsTabletScreenWidthOrThinner } from '../../../helpers/hooks/useScreenWidth';
import { getFishingWaterUrl } from '../../../helpers/urls';
import { Button } from '../../Clickables/Buttons/Button';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { ChevronDownIcon } from '../../Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../../Icons/ChevronUpIcon';
import { Text } from '../../Text/Text';

export const SEOWaterLink = () => {
  const isTabletScreenWidthOrThinner = useIsTabletScreenWidthOrThinner();
  const [showMore, setShowMore] = useState<boolean>(false);
  const pillsShown = isTabletScreenWidthOrThinner ? 3 : 10;

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between">
      <div className="flex flex-wrap gap-2">
        {TOP_SEARCHED_WATERS.map((water, index) => {
          const isHidden = index > pillsShown && !showMore;
          const { fishingWaterId, locationName, region } = water;
          const waterName = `${locationName}${region ? `, ${region}` : ''}`;
          return (
            <InternalLink
              variant="textPrimary"
              className={`flex h-min w-max items-center rounded-lg bg-sea-foam p-2 ${isHidden ? 'hidden' : ''}`}
              to={getFishingWaterUrl(fishingWaterId, locationName)}
              key={`SEOWaterLink-${fishingWaterId}`}
            >
              <Text variant="sm" className="mb-0">
                {waterName}
              </Text>
              <ArrowRightIcon className="ml-2" size={14} />
            </InternalLink>
          );
        })}
      </div>
      <div className="flex justify-center">
        {!showMore ? (
          <Button
            variant="textPrimary"
            className="size-[50px]"
            onClick={() => {
              setShowMore(true);
            }}
          >
            <ChevronDownIcon />
            <span className="sr-only">Show more</span>
          </Button>
        ) : (
          <Button
            variant="textPrimary"
            className="size-[50px]"
            onClick={() => {
              setShowMore(false);
            }}
          >
            <ChevronUpIcon />
            <span className="sr-only">Show less</span>
          </Button>
        )}
      </div>
    </div>
  );
};
